import React from "react";
import StoryCard from "./StoryCard";
import styles from "./Stories.module.scss";

const stories = [
  {
    title: "Collateral Desires",
    description:
      "Tasked with infiltrating Sinclair Industries to stop a bioweapon, you find yourself entangled in billionaire Kael Sinclair's perilous world of betrayal, revenge, and dangerous allure, where the fate of millions—and your own heart—hangs in the balance.",
    image:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/0ca53785c96c53e39bcdc388c101f605a85bd530a67ffc04925095b2dfe90569?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05",
    backgroundColor: "rgba(97, 8, 99, 0.4)",
  },
  {
    title: "Christmas Murder Mystery",
    description:
      "Dive into the 'Game of Games' Universe\nBecome the detective in a spine-chilling murder case",
    image:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/176415b375f3485756b35820d291b1242acf4cd6d23c294223991289a74eaf7a?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05",
    backgroundColor: "rgba(40, 4, 41, 1)",
    marginTop: "70px"

  }
];

export default function PopularStories() {
  return (
    <section className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.popularTag}>*Popular*</div>
        <div className={styles.storiesGrid}>
          <div className={styles.featuredStory}>
            <div className={styles.featuredContent}>
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/e03f4f5fc77b5c20a8a19e6b9fe0b5d514f05745591ffaff2aea8512ac75cb7b?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05"
                alt="Breaking the Code"
                className={styles.featuredImage}
                loading="lazy"
              />
              <div className={styles.featuredInfo}>
                <h2 className={styles.title}>Breaking the code</h2>
                <p className={styles.description}>
                  A reformed cybersecurity expert must navigate a high-stakes
                  investigation, rekindle buried secrets, and confront a
                  magnetic connection with a driven tech mogul, all while
                  risking everything to protect her future from a past that
                  threatens to resurface.
                </p>
                <button className={styles.playButton}>
                    <span className={styles.playText}>Play</span>
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/f0e8ef7b19ab39f796f89ca427de513b03ea93ee4869befa25d078bfc7dc26c4?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05"
                      alt=""
                      className={styles.playIcon}
                      loading="lazy"
                    />
                </button>
              </div>
            </div>
          </div>
          <div className={styles.storiesColumn}>
            {stories.map((story, index) => (
              <StoryCard key={index} {...story} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
